import './analytics'
import App from './components/App.svelte'
import './components/global.css'

new App({
	target: document.body,
})